import { inject } from '@angular/core';
import {
  CanActivateFn,
  GuardResult,
  MaybeAsync,
  Router,
} from '@angular/router';
import { AuthService } from '@infra-adapters/services/auth.service';

export const NotAuthGuard: CanActivateFn = (
  route,
  state
): MaybeAsync<GuardResult> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.isAuth().then((isAuth) => {
    if (!isAuth) {
      return true;
    } else {
      return router.createUrlTree(['/tutorial']);
    }
  })
};
